//require('./bootstrap');

/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
 */

// Bootstrap Components
require('./vendor/bootstrap/collapse');
require('./vendor/bootstrap/dropdown');
require('./vendor/bootstrap/tab');
require('./vendor/bootstrap/modal');

// Vendor Requires
require('./vendor/jquery.actual.min');
require('./vendor/picturefill');
require('./vendor/slick-slider');
require('./vendor/waypoint');
require('./vendor/waypoint-animate');
require('./vendor/js.cookie');

// App Requires
require('./app/expanding-search');
require('./app/modals');
require('./app/primary-navigation');
require('./app/sticky-nav');
require('./app/external');
require('./app/login');
require('./app/sliders/slider-resources');
require('./app/sliders/slider-split');
require('./app/recommender-tool');
require('./app/accordion');
require('./app/info-banner');
require('./app/responsive-tabs');
require('./app/maps');
require('./app/sba-loan-calculator');
require('./app/mailto-popup');